import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';

// PERSONAL COMPONENTS
import LayoutContainer from 'src/view/layouts/LayoutContainer.vue';
import RefreshTokenComponent from 'src/view/components/token/RefreshTokenComponent.vue';

// EXTENSIONS
import '@shared/extensions/array.extensions'

// Personal libs
import {
  addBusListeners,
  addEventListeners,
  removeBusListeners,
  removeEventListeners,
} from 'src/shared/lib/event.listener.lib';
import { logger } from '@shared/lib/logger/logger-manager';
import { dbUser } from './data/datasource/local/init.db.user';
import { dbData } from './data/datasource/local/init.db.data';
import { dbServiceWorker } from './data/datasource/local/init.db.service-worker';
import { UpdateManagerProgram } from '@shared/service/updateManager/update-manager-program.service';
import { UpdateManagerUi } from '@shared/service/updateManager/update-manager-ui.service';
import { RepositoryStrategyEnum } from '@shared/enum/repository-strategy.enum';
import { refreshLoginData } from '@shared/lib/login.lib';
import {
  serviceWorkerListeners,
  updateCachedVideoList,
} from '@shared/lib/service-worker.lib';
import { startCronJobs, stopCronJobs } from '@shared/lib/cronjob.lib';
import securityRepository from '@data/repository/security.repository';

/**
 * Globals
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// Vendor
const router = useRouter();

/**
 * Local database init
 */
// Open database if closed !
if (!dbUser.isOpen()) {
  logger?.info('[DEXIE] - App.vue - Open dbUser !');
  dbUser.open();
}
if (!dbData.isOpen()) {
  logger?.info('[DEXIE] - App.vue - Open dbData !');
  dbData.open();
}
if (!dbServiceWorker.isOpen()) {
  logger?.info('[DEXIE] - App.vue - Open dbServiceWorker !');
  dbServiceWorker.open();
}

/**
 * Init datas
 * TODO : call it "loadPublicData"
 */
new UpdateManagerProgram.ProgramAll().exec(
  RepositoryStrategyEnum.NETWORK_FIRST,
);
new UpdateManagerUi.UiConfigAll().exec(RepositoryStrategyEnum.NETWORK_FIRST);
new UpdateManagerUi.UiChangelog().exec(RepositoryStrategyEnum.NETWORK_FIRST);

/**
 * Hooks
 */
onBeforeMount(() => {
  // Get CSRF tokens for all forms
  securityRepository.getAllCsrf()

  // Refresh user's data
  refreshLoginData();

  // Refresh store
  updateCachedVideoList();

  // ********************************************************************
  // CRON TASKS
  // ********************************************************************
  startCronJobs()

  // ********************************************************************
  // EVENTS (service worker)
  // ********************************************************************
  serviceWorkerListeners();

  // ********************************************************************
  // EVENTS (window)
  // ********************************************************************
  addEventListeners();

  // ********************************************************************
  // EVENTS (bus)
  // ********************************************************************
  addBusListeners();
});

onBeforeUnmount(() => {
  removeEventListeners();
  removeBusListeners();
  stopCronJobs();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LayoutContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: 'fade',
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: _unref(router).currentRoute.value.fullPath
                }))
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(RefreshTokenComponent)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})